// constants/robotStyles.ts

import {
  KEYWORD_MESSAGE_ROBOT_INDEX,
  SEND_MESSAGE_ROBOT_INDEX,
  SET_TAG_ROBOT_INDEX,
  TASK_CREATING_ROBOT_INDEX,
  TRANSITION_FROM_THE_SALES_FUNNEL_ROBOT_INDEX,
  TRANSITION_FROM_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX,
  TRANSITION_TO_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX,
} from './botIndexes';

export const BOT_TYPE_STYLES: Record<string, string> = {
  [TRANSITION_TO_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX]: 'robot-type--gray',

  [TRANSITION_FROM_THE_SALES_FUNNEL_STAGE_ROBOT_INDEX]: 'robot-type--orange',

  [TRANSITION_FROM_THE_SALES_FUNNEL_ROBOT_INDEX]: 'robot-type--purple',

  [TASK_CREATING_ROBOT_INDEX]: 'robot-type--green',

  [SET_TAG_ROBOT_INDEX]: 'robot-type--yellow',

  [KEYWORD_MESSAGE_ROBOT_INDEX]: 'robot-type--cyan',

  [SEND_MESSAGE_ROBOT_INDEX]: 'robot-type--blue',
};

export const DEFAULT_BOT_TYPE_STYLE = 'robot-type--default';
